import { IRootState } from '../../app/store';

export const selectAppConfigs = (state: IRootState) =>
    state.appConfigs.appConfigs;

export const selectAppConfigsAsyncStatus = (state: IRootState) =>
    state.appConfigs.appConfigsAsyncStatus;
